import { render, staticRenderFns } from "./BannerShopByBrandCreate.vue?vue&type=template&id=1051ed78&"
import script from "./BannerShopByBrandCreate.vue?vue&type=script&lang=js&"
export * from "./BannerShopByBrandCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports